export const uiFooterNav = {
    name: 'UI Footer Nav',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        pages: {
            name: 'Pages',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['uiLink'] }],
                linkType: 'Entry'
            }
        }
    }
};
//# sourceMappingURL=uiFooterNav.js.map